// extracted by mini-css-extract-plugin
export default {"wrap":"ReferralView_wrap__EVgWI","tools":"ReferralView_tools__FCnh7","item":"ReferralView_item__80RKv","label":"ReferralView_label__55IWY","value":"ReferralView_value__N6QTn"};